import { makeStyles, Subtitle2, tokens } from "@fluentui/react-components"
import type { ReactElement, ReactNode } from "react"

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: tokens.spacingVerticalM,
    padding: `${tokens.spacingVerticalXXXL} ${tokens.spacingHorizontalXXL}`,
    textAlign: "center",
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "64px",
    height: "64px",
    borderRadius: tokens.borderRadiusCircular,
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorNeutralForeground3,
    fontSize: "32px",
  },
  description: {
    color: tokens.colorNeutralForeground3,
    maxWidth: "420px",
    margin: 0,
  },
})

export interface EmptyStateProps {
  icon?: ReactElement
  title: string
  description?: string
  // Acción primaria del vacío ("Aún no hay dominios — Crear el primero")
  action?: ReactNode
}

export const EmptyState = ({ icon, title, description, action }: EmptyStateProps) => {
  const styles = useStyles()
  return (
    <div className={styles.root} role="status">
      {icon ? <div className={styles.icon}>{icon}</div> : null}
      <Subtitle2 as="h2">{title}</Subtitle2>
      {description ? <p className={styles.description}>{description}</p> : null}
      {action}
    </div>
  )
}
